document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fvp-overlay').forEach(function (overlay) {
    var sectionId = overlay.id.replace('fvp-overlay-', '');
    var storageKey = 'fvp-seen-' + sectionId;
    var showMode = overlay.dataset.showMode || 'once';
    var delay = parseInt(overlay.dataset.delay, 10) || 0;

    var alreadySeen = false;
    if (showMode === 'once') {
      alreadySeen = window.localStorage.getItem(storageKey) === 'true';
    } else if (showMode === 'session') {
      alreadySeen = window.sessionStorage.getItem(storageKey) === 'true';
    }

    if (alreadySeen) return;

    var openTimer = setTimeout(function () {
      overlay.classList.add('fvp-visible');
      document.body.style.overflow = 'hidden';

      if (showMode === 'once') {
        window.localStorage.setItem(storageKey, 'true');
      } else if (showMode === 'session') {
        window.sessionStorage.setItem(storageKey, 'true');
      }
    }, delay);

    function closePopup() {
      clearTimeout(openTimer);
      overlay.classList.remove('fvp-visible');
      document.body.style.overflow = '';
    }

    var closeBtn = document.getElementById('fvp-close-' + sectionId);
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    var dismissBtn = document.getElementById('fvp-dismiss-' + sectionId);
    if (dismissBtn) dismissBtn.addEventListener('click', closePopup);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('fvp-visible')) {
        closePopup();
      }
    });
  });
});